export default "__VITE_ASSET__DJRlzTKx__"